module.exports = __webpack_public_path__ + "static/Banner carrousel home Enero-03-72b915b820e4a43c2f1740cf1e0743f2.jpg";